import { RequestBase } from "./request-base";
import { ResponseBase } from "./response-base";

export class RequestAccess extends RequestBase {

  route?: string;

  authId?: string;

  authIntAppCode?: string;

  roleIntAppCode?: string;

  moduleIntAppCode?: string;
}

export class ResponseAccess extends ResponseBase {

  isLicensed?: boolean | null;

  expiresOn?: Date | null;
}
